<template>
    <div v-loading="filterLoading">
        <div style="margin-bottom: 20px;">
            <el-form>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item
                                label="Raktár"
                        >
                            <el-select
                                    v-model="storage"
                                    value-key="id"
                                    style="width: 100%;"
                                    filterable
                                    @change="handleStorageChange"
                            >
                                <el-option
                                        v-for="s in storages"
                                        :key="s.id"
                                        :label="s.name"
                                        :value="s"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item style="margin-right: 10px;"
                                      label="Beszállító"
                        >
                            <el-select
                                v-model="supplier"
                                filterable
                                remote
                                :remote-method="searchPartner"
                                :loading="partnerLoading"
                                placeholder="Gépelj a kereséshez..."
                                style="width: 100%;"
                                value-key="id"
                                @change="handleSupplierChange"
                                clearable
                            >
                                <el-option
                                    v-for="p in partners"
                                    :key="p.company.id"
                                    :value="p"
                                    :label="p.company.name"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">

                        <el-form-item
                                label="Termék"
                        >
                            <el-select
                                    v-model="product"
                                    filterable
                                    remote
                                    :remote-method="searchProduct"
                                    :loading="productLoading"
                                    placeholder="Gépelj a kereséshez..."
                                    style="width: 100%;"
                                    value-key="id"
                                    @change="handleProductChange"
                                    clearable
                            >
                                <el-option
                                        v-for="p in products"
                                        :key="p.id"
                                        :value="p"
                                        :label="p.name"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <div class="" style="text-align: right; margin-top: 40px;">
                            <el-button
                                    :loading="downloadLoading"
                                    icon="el-icon-download"
                                    @click="download"
                            >
                                Letöltés
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

        </div>
        <el-table
                v-loading="loading"
                :data="storageStock.data"
                @sort-change="handleSortChange"
                :default-sort="{prop: 'product_name', order: 'ascending'}"
        >
            <!--<el-table-column-->
            <!--label="#"-->
            <!--prop="creatorUserId"--
            <!--width="70"-->
            <!--&gt;-->
            <!--</el-table-column>-->
            <el-table-column
                    label="Termék"
                    prop="product_name"
                    sortable="custom"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-link type="primary" @click="$router.replace('/reports/storage-stock/view/products/' + scope.row.product_id + '/storages/' + storage.id)">
                        {{ scope.row.product_name }}
                    </el-link>
                </template>

            </el-table-column>


            <el-table-column
                    label="Saját készlet"
                    prop="own_stock"
                    align="right"
                    sortable="custom"
                    width="210"
            >
                <template slot-scope="scope">
                    {{ scope.row.own_stock }} {{ scope.row.pack_type_name == 'egyesével' ? 'db' : scope.row.pack_type_name }}
                </template>
            </el-table-column>

            <el-table-column
                    label="Tervezett készlet"
                    prop="supplier_order_stock"
                    align="right"
                    sortable="custom"
                    width="210"
            >
                <template slot-scope="scope">
                    {{ scope.row.supplier_order_stock }} {{ scope.row.pack_type_name == 'egyesével' ? 'db' : scope.row.pack_type_name }}
                </template>
            </el-table-column>

            <el-table-column
                    label="Foglalt készlet"
                    prop="customer_order_stock"
                    align="right"
                    sortable="custom"
                    width="210"
            >
                <template slot-scope="scope">
                    {{ scope.row.customer_order_stock}} {{ scope.row.pack_type_name == 'egyesével' ? 'db' : scope.row.pack_type_name }}
                </template>
            </el-table-column>

            <el-table-column
                    label="Felhasználható készlet"
                    prop="available_stock"
                    align="right"
                    sortable="custom"
                    width="210"
            >
                <template slot-scope="scope">
                    {{ scope.row.available_stock}} {{ scope.row.pack_type_name == 'egyesével' ? 'db' : scope.row.pack_type_name }}
                </template>
            </el-table-column>

          <el-table-column
            label="Db / kisz."
            align="right"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.count_per_pack }}
            </template>
          </el-table-column>
        </el-table>

        <div class="el-card-footer">
            <el-pagination
                    background
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="storageStock.per_page"
                    layout="total, prev, pager, next"
                    :total="storageStock.total"
                    @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {saveAs} from 'file-saver';

    export default {
        data() {
            const start = moment()
                .startOf('year')
                .format('Y-MM-DD');
            const end = moment()
                .format('Y-MM-DD');
            return {
                downloadLoading: false,
                products: [],
                productLoading: false,
                filterLoading: false,
                partners: [],
                partnerLoading: false,
            };
        },

        computed: {
            currentPage() {
                return this.$store.getters['storageStockReport/currentPage'];
            },

            storageStock() {
                return this.$store.getters['storageStockReport/storageStock'];
            },

            loading() {
                return this.$store.getters['storageStockReport/loading'];
            },

            storages() {
                return this.$store.getters['storage/storages'];
            },

            product: {
                get() {
                    return this.$store.state.storageStockReport.product;
                },
                set(value) {
                    this.$store.commit('storageStockReport/setProduct', value)
                }
            },

            storage: {
                get() {
                    return this.$store.state.storageStockReport.storage;
                },
                set(value) {
                    this.$store.commit('storageStockReport/setStorage', value)
                    this.$store.commit('storageStockReport/setStorageInDialog', value)
                }
            },

            supplier: {
                get() {
                    return this.$store.state.storageStockReport.supplier;
                },
                set(value) {
                    this.$store.commit('storageStockReport/setSupplier', value)
                }
            },
        },

        methods: {

            async fetchAll() {
                await this.$store.dispatch('storageStockReport/fetchAll')
            },

            handleCurrentChange(val) {
                this.$store.commit('storageStockReport/setCurrentPage', val)
                this.fetchAll();
            },

            handleSortChange({column, prop, order}) {
                this.$store.commit('storageStockReport/setSorting', {
                    prop: prop,
                    order: order,
                })
                this.$store.commit('storageStockReport/setCurrentPage', 1)
                this.fetchAll();
            },

            handleProductChange() {
                this.$store.commit('storageStockReport/setCurrentPage', 1)
                this.fetchAll();
            },

            handleStorageChange() {
                this.$store.commit('storageStockReport/setCurrentPage', 1)
                this.fetchAll();
            },

            handleSupplierChange() {
                this.$store.commit('storageStockReport/setCurrentPage', 1)
                this.fetchAll();
            },

            async searchProduct(query) {
                if (query !== '') {
                    this.productLoading = true;
                    this.products = await this.$store.dispatch('product/search', '?name=' + query);
                    this.productLoading = false;
                }
            },

            async download() {
                this.downloadLoading = true;
                try {
                    const excel = await axios({
                        url: `api/reports/storage-stock/download`,
                        method: 'POST',
                        responseType: 'blob',
                        data: {
                            product_id: this.product && this.product.id ? this.product.id : null,
                            storage_id: this.storage && this.storage.id ? this.storage.id : null,
                            supplier_id: this.supplier && this.supplier.id ? this.supplier.id: null,
                        },
                    });
                    saveAs(excel, `storagestock.xlsx`);
                } catch (e) {}
                this.downloadLoading = false;
            },

            async searchPartner(query) {
                if (query !== '') {
                    this.partnerLoading = true;
                    this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
                    this.partnerLoading = false;
                }
            },
        },

        async mounted() {
            this.filterLoading = true;
            if (!this.storages.length) {
                await this.$store.dispatch('storage/fetchAll');
            }
            const storage =  this.storages.find(s => s.type === 'own') || this.storages[0]
            this.$store.commit('storageStockReport/setStorage', storage);
            this.$store.commit('storageStockReport/setStorageInDialog', storage)

            this.fetchAll();
            this.filterLoading = false;

        },
    };
</script>
